/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions } from './FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions';
import {
    instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions,
    FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsFromJSON,
    FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsFromJSONTyped,
    FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsToJSON,
} from './FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions';

/**
 * @type FxIdWebFeaturesStoreCreatePaymentRequestPlutus
 * 
 * @export
 */
export type FxIdWebFeaturesStoreCreatePaymentRequestPlutus = FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions;

export function FxIdWebFeaturesStoreCreatePaymentRequestPlutusFromJSON(json: any): FxIdWebFeaturesStoreCreatePaymentRequestPlutus {
    return FxIdWebFeaturesStoreCreatePaymentRequestPlutusFromJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreCreatePaymentRequestPlutusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesStoreCreatePaymentRequestPlutus {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions(json)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdWebFeaturesStoreCreatePaymentRequestPlutusToJSON(json: any): any {
    return FxIdWebFeaturesStoreCreatePaymentRequestPlutusToJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreCreatePaymentRequestPlutusToJSONTyped(value?: FxIdWebFeaturesStoreCreatePaymentRequestPlutus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions(value)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptionsToJSON(value as FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestPlutusOptions);
    }

    return {};
}

